import MaxLogo from '@assets/max-logo.jpg';
import { BrandedBackgroundContainer } from '@components/core';
import { Box, LinearProgress, styled, Typography } from '@mui/material';
import { CobrandImage } from '@src/types/get-cobrand-response';

const GradientLinearProgress = styled(LinearProgress)(({ theme }) => ({
  '& .MuiLinearProgress-bar': {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  },
}));

export type FullPageLoaderProps = {
  cobrandImage?: CobrandImage;
};

const FullPageLoader = ({ cobrandImage }: FullPageLoaderProps) => {
  return (
    <BrandedBackgroundContainer>
      <Box
        bgcolor={(theme) => theme.palette.background.paper}
        display='flex'
        justifyContent='center'
        alignItems='center'
        width='300px'
        margin='auto'
        flexDirection='column'
        sx={(theme) => ({ padding: theme.spacing(4) })}
        borderRadius={(theme) => theme.shape.borderRadius}
      >
        <Box
          data-testid='logo'
          component='img'
          src={cobrandImage?.url ?? MaxLogo}
          aria-label={cobrandImage?.altText ?? 'Max Logo'}
          sx={{ width: '200px', height: 'auto' }}
        />
        <Box mt={4} width='100%' display='flex' flexDirection='column' gap={2}>
          <Typography variant='body1' color='secondary' textAlign='center'>
            Loading
          </Typography>
          <Box mt={2}>
            <GradientLinearProgress />
          </Box>
        </Box>
      </Box>
    </BrandedBackgroundContainer>
  );
};

export default FullPageLoader;
